// extracted by css-extract-rspack-plugin
export default {"cls1":"useNoClaimsToast-cls1_qg9","cls2":"useNoClaimsToast-cls2_LYl useNoClaimsToast-cls1_qg9"};